import * as types from './mutation-types'

const namespaced = true

const initialState = {
    list: []
}

const mutations = {
    [types.PUT_ELECTIONS](state, elections) {
        state.list = elections
    }
}

const actions = {
    set: ({commit}) => (
        fetch("https://forecasting-data.decisiondeskhq.com/2022/prod/elections.json")
            .then((response) => {
                if (!response.ok) {
                    throw new Error(response.status);
                }

                return response.json();
            })
            .then((data) => {
                commit(types.PUT_ELECTIONS, data)
                return data
            })
            .catch((error) => {
                // eslint-disable-next-line
                console.error(error);
            })
    )
}

const getters = {
    list(state) {
        return state.list
    }
}

export default {
    namespaced,
    state: initialState,
    mutations,
    actions,
    getters
}
